<style src="./style.scss">
</style>

<script>
  import classNames from "classnames/bind";

  export let title;
  export let type = "primary";
  export let disabled = false;
  export let bottomButtom = false;
  export let onClick = () => null;

  const className = classNames("button", {
    "button-primary": type === "primary",
    "button-secondary": type === "secondary",
    "button-success": type === "success",
    "button-bottom": bottomButtom,
  });
</script>

<button
  class="{className}"
  disabled="{disabled}"
  on:click="{onClick}"
  {...$$props}>{title}</button>
